module.exports = __webpack_public_path__ + "img/Airavata_logo_ext.4458cc51.png";